document.addEventListener('DOMContentLoaded', function () {
    // Add this console log to confirm the script is running
    console.log("Modal script loaded and running");

    // Get references to modal elements
    const submitModal = document.getElementById('verticallyCenter');
    const modalTitle = document.getElementById('verticallyCenterLabel');
    const modalBody = submitModal ? submitModal.querySelector('.modal-body') : null;
    const modalFooter = submitModal ? submitModal.querySelector('.modal-footer') : null;

    // Check if the modal exists and log the elements for debugging
    console.log("Modal elements:", { submitModal, modalTitle, modalBody, modalFooter });
    if (!submitModal || !modalBody || !modalFooter) {
        console.error("Missing modal elements");
        return;
    }

    // Store the modal instance for later use
    let modalInstance;
    submitModal.addEventListener('shown.bs.modal', function () {
        console.log("Modal shown event triggered");
        modalInstance = bootstrap.Modal.getInstance(submitModal);

        // Debug check - make sure footer is available when modal is shown
        console.log("Footer element when modal shown:", modalFooter);
        console.log("Footer content when modal shown:", modalFooter.innerHTML);
    });

    // Helper function to determine if the form is valid
    function isFormValid() {
        // For debugging - log that validation is running
        console.log("Running form validation");

        // Get form values
        const clientName = document.getElementById('clientName');
        const policyNumber = document.getElementById('policyNumber');
        const vehicleRegistration = document.getElementById('vehicleRegistration');
        const driverName = document.getElementById('driverName');
        const incidentDescription = document.getElementById('incidentDescription');
        const declarationCheck = document.getElementById('declarationCheck');

        // Validate required fields
        if (!clientName || !clientName.value.trim()) {
            return {
                valid: false,
                message: "Please enter a Client Name."
            };
        }

        if (!policyNumber || policyNumber.value === "") {
            return {
                valid: false,
                message: "Please select a Policy Number."
            };
        }

        if (!vehicleRegistration || !vehicleRegistration.value.trim()) {
            return {
                valid: false,
                message: "Please enter a Vehicle Registration Number."
            };
        }

        if (!driverName || !driverName.value.trim()) {
            return {
                valid: false,
                message: "Please enter a Driver Name."
            };
        }

        if (!incidentDescription || !incidentDescription.value.trim()) {
            return {
                valid: false,
                message: "Please provide an Incident Description."
            };
        }

        if (!declarationCheck || !declarationCheck.checked) {
            return {
                valid: false,
                message: "Please agree to the declaration before submitting the claim."
            };
        }

        // If all validations pass
        return {
            valid: true,
            message: "All required information has been provided. Your claim is ready to be submitted."
        };
    }

    // Function to update modal content and footer based on validation results
    function updateModal(validationResult) {
        console.log("Updating modal with validation result:", validationResult);

        // Generate a claim reference for display (actual claim ID will be generated later)
        const tempClaimRef = `CLM-${Math.floor(10000 + Math.random() * 90000)}`;

        // Update the modal title and body content
        if (validationResult.valid) {
            modalTitle.textContent = "Submit Claim";
            modalBody.innerHTML = `
                <div class="alert alert-success mb-4">
                    <i class="ph ph-check-circle me-2"></i>
                    ${validationResult.message}
                </div>
                <div class="mb-3">
                    <p>Claim Reference: <strong>${tempClaimRef}</strong></p>
                    <p>Submitted Date: <strong>${new Date().toLocaleDateString()}</strong></p>
                </div>
                <p class="small text-muted">Click "Confirm Submission" to process this claim.</p>
            `;

            console.log("Setting footer HTML for valid form");
            // Set footer with two buttons for valid form
            modalFooter.innerHTML = `
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-success" id="confirm-submission">Confirm Submission</button>
            `;
            console.log("Footer HTML after setting:", modalFooter.innerHTML);

            // Add event listener to the confirm button
            const confirmBtn = document.getElementById('confirm-submission');
            console.log("Confirm button found:", confirmBtn);
            if (confirmBtn) {
                confirmBtn.addEventListener('click', handleConfirmSubmission);
                console.log("Click handler added to confirm button");
            } else {
                console.error("Confirm button not found after adding to DOM");
            }
        } else {
            modalTitle.textContent = "Cannot Submit Claim";
            modalBody.innerHTML = `
                <div class="alert alert-danger mb-4">
                    <i class="ph ph-warning-circle me-2"></i>
                    ${validationResult.message}
                </div>
                <p>Please complete all required information before submitting the claim.</p>
            `;

            console.log("Setting footer HTML for invalid form");
            // Set footer with only Okay button for invalid form
            modalFooter.innerHTML = `
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Okay</button>
            `;
            console.log("Footer HTML after setting:", modalFooter.innerHTML);
        }
    }

    // Handler for the confirm submission button
    function handleConfirmSubmission() {
        console.log("Confirm submission button clicked");
        const confirmBtn = this;

        // Show loading state
        confirmBtn.disabled = true;
        confirmBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing...';

        // CRITICAL CHANGE: Use proper ClaimsManager submission flow
        // that preserves the original draft ID

        // Get the claim ID from URL or hidden field
        let claimId = '';
        const hiddenClaimId = document.getElementById('hidden-claim-id');

        if (hiddenClaimId && hiddenClaimId.value) {
            claimId = hiddenClaimId.value;
            console.log("Using preserved claim ID from hidden field:", claimId);
        } else {
            // Try to get from URL
            const urlParams = new URLSearchParams(window.location.search);
            claimId = urlParams.get('claimId');
            console.log("Using claim ID from URL:", claimId);
        }

        // Check if ClaimsManager is available
        if (window.ClaimsManager && typeof ClaimsManager.handleClaimSubmission === 'function') {
            console.log("Using ClaimsManager.handleClaimSubmission with ID:", claimId);

            // This will use our improved submission flow that properly handles drafts
            ClaimsManager.handleClaimSubmission();

            // Use the claimId from the URL for the success message
            // (the updated ClaimsManager.handleClaimSubmission will use this same ID)
            setTimeout(() => {
                processSubmissionResult(claimId || 'Unknown');
            }, 1500);
        } else {
            // Fallback to the original code if ClaimsManager isn't available or is missing our new method
            console.log("Using legacy submission flow");

            // Collect form data for the new claim
            const clientName = document.getElementById('clientName').value.trim();
            const policyNumber = document.getElementById('policyNumber').value;
            const vrn = document.getElementById('vehicleRegistration').value.trim();
            const driverName = document.getElementById('driverName').value.trim();
            const incidentDescription = document.getElementById('incidentDescription').value.trim();

            // Get incident type from the form if available, or extract from description
            let incidentType = document.getElementById('incident-type-value')?.value;
            if (!incidentType) {
                // Extract from description as fallback
                if (incidentDescription.toLowerCase().includes('accident')) {
                    incidentType = 'Accident';
                } else if (incidentDescription.toLowerCase().includes('theft')) {
                    incidentType = 'Theft';
                } else if (incidentDescription.toLowerCase().includes('windscreen')) {
                    incidentType = 'Windscreen';
                } else if (incidentDescription.toLowerCase().includes('vandalism')) {
                    incidentType = 'Vandalism';
                } else {
                    incidentType = 'Accident'; // Default
                }
            }

            if (window.ClaimsManager) {
                const newClaim = {
                    claimId: claimId, // Use existing ID if available
                    clientName,
                    policyNumber,
                    vrn,
                    driverName,
                    status: 'Submitted',
                    incidentType,
                    description: incidentDescription,
                    submitted: true // Mark as submitted
                };

                const addedClaim = ClaimsManager.addClaim(newClaim);
                claimId = addedClaim.claimId;

                // Also try to remove any drafts with this ID
                if (typeof ClaimsManager.deleteDraftClaim === 'function') {
                    ClaimsManager.deleteDraftClaim(claimId);
                }

                console.log('Claim submitted via legacy ClaimsManager.addClaim:', addedClaim);
            } else {
                // Fallback if ClaimsManager isn't available at all
                claimId = generateTempClaimId();
                console.log('ClaimsManager not available, using temp claim ID:', claimId);
            }

            // Process the result
            setTimeout(() => {
                processSubmissionResult(claimId);
            }, 1500);
        }

        // Separate the success UI update into its own function
        function processSubmissionResult(claimId) {
            console.log("Processing complete, updating modal with ID:", claimId);
            // Update modal with success confirmation
            modalBody.innerHTML = `
                <div class="alert alert-success mb-4">
                    <i class="ph ph-check-circle me-2"></i>
                    Claim submitted successfully!
                </div>
                <p>Your claim has been submitted and is now being processed.</p>
                <p>A confirmation email will be sent to the registered address shortly.</p>
                <p class="mt-3">Claim Reference: <strong>${claimId}</strong></p>
            `;

            console.log("Updating footer for success state");
            // Update footer for success state - just one button to go to dashboard
            modalFooter.innerHTML = `
                <button type="button" class="btn btn-success" id="go-to-dashboard">View Dashboard</button>
            `;
            console.log("Footer HTML after setting dashboard button:", modalFooter.innerHTML);

            // Add event listener to the new button
            const dashboardBtn = document.getElementById('go-to-dashboard');
            console.log("Dashboard button found:", dashboardBtn);
            if (dashboardBtn) {
                dashboardBtn.addEventListener('click', function () {
                    console.log("Dashboard button clicked, redirecting");
                    window.location.href = "index.html";
                });
            } else {
                console.error("Dashboard button not found after adding to DOM");
            }
        }
    }

    // Generate a temporary claim ID if ClaimsManager isn't available
    function generateTempClaimId() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';

        let id = '';

        // Generate 3 random letters
        for (let i = 0; i < 3; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        // Generate 3 random numbers
        for (let i = 0; i < 3; i++) {
            id += numbers.charAt(Math.floor(Math.random() * numbers.length));
        }

        return id;
    }

    // Handle the submit button click
    const submitBtn = document.getElementById('submit-claim');
    console.log("Submit button found:", submitBtn);
    if (submitBtn) {
        submitBtn.addEventListener('click', function (event) {
            console.log("Submit button clicked");
            // We want to show the modal, but we need to check validation first
            event.preventDefault();

            // IMPORTANT ADDITION: Preserve the claim ID before opening the modal
            preserveClaimIdBeforeModal();

            // Clean up any lingering backdrops first
            cleanupModalBackdrops();

            // Do validation
            const validationResult = isFormValid();
            console.log("Validation result:", validationResult);

            if (!validationResult.valid) {
                console.log("Validation failed, handling failure");
                // If validation fails, handle it appropriately
                handleValidationFailure(validationResult);
                return; // Don't show the modal
            }

            console.log("Validation passed, updating modal");
            // If validation passes, update modal and show it
            updateModal(validationResult);

            // For testing, try to directly add buttons after a delay
            setTimeout(() => {
                console.log("Delayed check - footer content:", modalFooter.innerHTML);
                if (!modalFooter.querySelector('button')) {
                    console.log("No buttons found after delay, forcing buttons");
                    modalFooter.innerHTML = `
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-success" id="confirm-submission">Confirm Submission</button>
                    `;

                    const confirmBtn = document.getElementById('confirm-submission');
                    if (confirmBtn) {
                        confirmBtn.addEventListener('click', handleConfirmSubmission);
                    }
                }
            }, 500);
        });
    } else {
        console.error("Submit button not found");
    }

    function preserveClaimIdBeforeModal() {
        // Get claim ID from URL
        const urlParams = new URLSearchParams(window.location.search);
        const claimId = urlParams.get('claimId');

        if (claimId) {
            console.log("Preserving claim ID before modal:", claimId);

            // Create or update hidden field
            let hiddenClaimId = document.getElementById('hidden-claim-id');
            if (!hiddenClaimId) {
                hiddenClaimId = document.createElement('input');
                hiddenClaimId.type = 'hidden';
                hiddenClaimId.id = 'hidden-claim-id';
                document.body.appendChild(hiddenClaimId);
            }

            hiddenClaimId.value = claimId;
        }

        // If ClaimsManager has a preserveClaimIdInModal function, also call that
        if (window.ClaimsManager && typeof ClaimsManager.preserveClaimIdInModal === 'function') {
            ClaimsManager.preserveClaimIdInModal();
        }
    }
    
    // Handle validation failure - open relevant section and show message
    function handleValidationFailure(validationResult) {
        console.log("Handling validation failure:", validationResult);

        // Find and open the relevant section based on the validation message
        let sectionToOpen = null;

        if (validationResult.message.includes('declaration')) {
            sectionToOpen = 'collapseTen'; // Declaration section
        }
        else if (validationResult.message.includes('Client Name') ||
            validationResult.message.includes('Policy Number') ||
            validationResult.message.includes('Vehicle Registration') ||
            validationResult.message.includes('Driver Name')) {
            sectionToOpen = 'collapseOne'; // Policy details
        }
        else if (validationResult.message.includes('Incident Description')) {
            sectionToOpen = 'collapseTwo'; // Incident description
        }

        console.log("Section to open:", sectionToOpen);

        // Open the relevant section
        if (sectionToOpen) {
            const accordionButton = document.querySelector(`button[data-bs-target="#${sectionToOpen}"]`);
            console.log("Accordion button found:", accordionButton);
            if (accordionButton && accordionButton.classList.contains('collapsed')) {
                accordionButton.click();
            }

            // Scroll to the section
            accordionButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    // Function to clean up lingering backdrops
    function cleanupModalBackdrops() {
        const backdrops = document.querySelectorAll('.modal-backdrop');
        console.log("Cleaning up backdrops, found:", backdrops.length);
        backdrops.forEach(backdrop => {
            backdrop.remove();
        });
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }

    // Clean up any existing backdrops on page load
    cleanupModalBackdrops();

    // Add an event listener to clean up after modal closes
    if (submitModal) {
        submitModal.addEventListener('hidden.bs.modal', function () {
            console.log("Modal hidden event triggered");
            cleanupModalBackdrops();
        });
    }

    // Additional direct implementation without relying on data-bs-toggle
    if (submitBtn && submitModal) {
        console.log("Setting up direct modal control");
        submitBtn.onclick = function (e) {
            e.preventDefault();

            // Create a bootstrap modal instance directly
            if (!modalInstance) {
                console.log("Creating modal instance directly");
                try {
                    modalInstance = new bootstrap.Modal(submitModal);
                } catch (err) {
                    console.error("Error creating modal instance:", err);
                }
            }

            // Validate
            const validationResult = isFormValid();

            // Update modal before showing it
            updateModal(validationResult);

            // Try to show the modal
            if (modalInstance) {
                console.log("Showing modal using instance");
                modalInstance.show();
            } else {
                console.log("Falling back to show method");
                // Fallback to jQuery
                try {
                    $(submitModal).modal('show');
                } catch (err) {
                    console.error("Error with jQuery modal show:", err);
                }
            }
        };
    }
});